/* global modForm modUtils Modalytics */
import { switchFormLoadingState, processAPIResponseErrors, showNextStep } from '../../helpers';

/**
 * Process form after succesful submit
 * @param {Object} response - response data
 * @param {Number} currentStep - current step index
 * @param {Object} xhr - xhr
 */
export function processContractorFormSubmitSuccess(response, currentStep, xhr) {
	let heapTrackData;

	// Handle errors
	// This needs to get worked on for better identification, since the PATCH call doesn't return any response,
	// we can't assume "having no response" is the way of saying there was an error
	// Would like to know how can I replicate this behaviour first for a more thorough testing
	if (xhr.statusText === 'error') {
		heapTrackData = {
			message: 'Failed Contractor Signup Form Submit',
			data: modForm.opts.landingPage
		};

		if ('function' === typeof modForm.opts.formSubmitErrorCallback) {
			modForm.opts.formSubmitErrorCallback(response);
		}

		switchFormLoadingState(false);
		processAPIResponseErrors(response);

		return;
	}

	// Identify user in Heap if there's an Id
	if (response && response.data.contractorId) {
		Modalytics.heap('identify', [response.data.contractorId, 'ID']);
	}

	if (currentStep === 0) {
		// If first step submission was succesful
		if (response && xhr.status === 201) {
			const $contractorId = modForm.opts.form.querySelector('[name="contractorId"]'),
				$token = modForm.opts.form.querySelector('[name="token"]');

			$contractorId.value = response.data.contractorId;
			$token.value = response.data.token;

			// Storing token value on a cookie under modernize domain
			modForm.opts.sessionObj = {
				token: response.data.token
			};
			modUtils.setCookie(
				'mod-session',
				encodeURIComponent(JSON.stringify(modForm.opts.sessionObj))
			);

			heapTrackData = {
				message: 'Successful Contractor Signup Form Submit Step 1',
				data: response.data.contractorId
			};

			// Thankyou blocks logic
			const $tyStateBlocks = modForm.opts.form.querySelectorAll('.ty-state-block'),
				$generalTyp = modForm.opts.form.querySelector('.ty-state-block-success'),
				tyStateGAName = 'thankyou';

			// Switch form to TY state
			modForm.opts.form.classList.add(modForm.opts.formTyCls);

			// Check what type of TY page to show
			if ($tyStateBlocks && $tyStateBlocks.length) {
				$tyStateBlocks.forEach(function(el) {
					el.style.display = 'none';
				});
			}

			$generalTyp.style.display = 'block';

			// Track TY page in GA
			Modalytics.gaSend({
				hitType: 'pageview',
				page: modForm.opts.landingPage + tyStateGAName + '/'
			}, modForm.opts.gaTracker);
		}
	}

	// Track data in Heap
	Modalytics.heap('track', [heapTrackData.message, heapTrackData.data]);

	showNextStep();
}
